<div *ngIf="initialized" class="w3-container w3-margin-top" [class]="router.back ? 'w3-animate-left' : 'w3-animate-right'">
  <omnipas-pageheader></omnipas-pageheader>
  <div *ngIf="message.success" class="w3-padding">
    <button
      id          = "login"
      name        = "login"
      class       = "w3-button w3-border w3-button-theme"
      title       = "{{ 'buttons.home' | translate: router.transparams }}"
      (click)     = "router.goHome()"
    >
      {{ 'buttons.home' | translate: router.transparams }}
    </button>
  </div>
  <form *ngIf="!invalidLink && !message.success" action="" method="">
    <div class="w3-margin">
      <label for="password">{{ 'labels.password' | translate: router.transparams }}</label>
      <input
        id            = "password"
        type          = "password"
        name          = "password"
        class         = "w3-input w3-border w3-input-theme password"
        placeholder   = "{{ 'labels.password' | translate: router.transparams }}"
        autocomplete  = "current-password"
        [(ngModel)]   = "password"
        required      = "required"
        tabindex      = "1"
      >
      <fa-icon
        id          = "togglePassword"
        name        = "togglePassword"
        [icon]      = "eye"
        (mouseover) = "togglePassword( true )"
        (mouseout)  = "togglePassword( false )"
        title       = "{{ 'login.showhide' | translate: router.transparams }}"
      ></fa-icon>
    </div>
    <div class="w3-margin">
      <label for="password">{{ 'labels.repeatpassword' | translate: router.transparams }}</label>
      <input
        id            = "repeatpassword"
        name          = "repeatpassword"
        type          = "password"
        class         = "w3-input w3-border w3-input-theme password"
        placeholder   = "{{ 'labels.repeatpassword' | translate: router.transparams }}"
        autocomplete  = "current-password"
        [(ngModel)]   = "repeatpassword"
        required      = "required"
        (keyup.enter) = "submit()"
        tabindex      = "2"
      >
      <fa-icon
        id          = "toggleRepeatPassword"
        name        = "toggleRepeatPassword"
        [icon]      = "eyerepeat"
        (mouseover) = "toggleRepeatPassword( true )"
        (mouseout)  = "toggleRepeatPassword( false )"
        title       = "{{ 'login.showhide' | translate: router.transparams }}"
      ></fa-icon>
    </div>
    <div class="w3-margin">
      <input
        type        = "reset"
        id          = "reset"
        name        = "reset"
        class       = "w3-button w3-border w3-button-theme w3-margin-right pageButton w3-round"
        title       = "{{ 'buttons.reset' | translate: router.transparams }}"
        value       = "{{ 'buttons.reset' | translate: router.transparams }}"
        (click)     = "reset()"
        [disabled]  = "enableReset() ? '' : 'disabled'"
        tabindex    = "3"
      >
      <input
        type        = "submit"
        id          = "submit"
        name        = "submit"
        class       = "w3-button w3-border w3-button-theme pageButton w3-round"
        title       = "{{ 'buttons.save' | translate: router.transparams }}"
        value       = "{{ 'buttons.save' | translate: router.transparams }}"
        (click)     = "submit()"
        [disabled]  = "enableSubmit() ? '' : 'disabled'"
        tabindex    = "4"
      >
    </div>
  </form>
</div>
